import React from 'react'
import './Overlay.scss';

const Overlay = () => {
  return (
    <div className="overlay" />
  )
};

export default Overlay;